module.exports = __webpack_public_path__ + "img/yolcu360.98176509.png";